export default __webpack_public_path__ + "static/media/Priest's Cord of Balance.347294c0.jpg";